module.exports = __webpack_public_path__ + "static/media/marca png 1.fbc26cbb.png";